import { BotNodeId, UxEvent } from '../types';
import * as BotMessages from './botMessages';
import OrdersUncapturedOrdersBotMessage from '../components/botMessages/OrdersUncapturedOrdersBotMessage';
import OrdersUncapturedOrdersYesBotMessage from '../components/botMessages/OrdersUncapturedOrdersYesBotMessage';
import OrdersUncapturedOrdersNoBotMessage from '../components/botMessages/OrdersUncapturedOrdersNoBotMessage';
import OrdersExpirationDateSurpassedNo from '../components/botMessages/OrdersExpirationDateSurpassedNoBotMessage';
import OrdersIsOrderCapturedBotMessage from '../components/botMessages/OrdersIsOrderCapturedBotMessage';
import OrdersIsOrderCapturedNoBotMessage from '../components/botMessages/OrdersIsOrderCapturedNoBotMessage';
import { useOrdersDataState } from '../../../context/OrdersDataStateProvider';
const INeedMoreHelpThatHelped = [{
        value: 'helpbot.options.iNeedMoreHelp',
        next: UxEvent.GO_TO_CHANNEL_SELECTION
    },
    {
        value: 'helpbot.options.thatHelped',
        next: BotNodeId.THAT_HELPED
    }];
const useOrdersDontKnowCaptureOrderOptions = () => {
    const defaultOptions = [{
            value: 'helpbot.options.yes',
            next: BotNodeId.ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER_YES
        },
        {
            value: 'helpbot.options.no',
            next: BotNodeId.ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER_NO
        }];
    const { data: { nbUncapturedOrders } } = useOrdersDataState();
    if (nbUncapturedOrders.hasError)
        return defaultOptions;
    return INeedMoreHelpThatHelped;
};
const ordersFlow = [{
        id: BotNodeId.SELECT_ORDERS,
        botMessage: BotMessages.SelectOrderIssueBotMessage,
        options: () => [{
                value: 'helpbot.options.dontKnowHowToCaptureOrder',
                next: BotNodeId.ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER
            }, {
                value: 'helpbot.options.missedCaptureDeadline',
                next: BotNodeId.ORDERS_MISSED_CAPTURE_DEADLINE
            }, {
                value: 'helpbot.options.needToRefundAnOrder',
                next: BotNodeId.ORDERS_REFUND_AN_ORDER
            }, {
                value: 'helpbot.options.otherIssue',
                next: UxEvent.GO_TO_CHANNEL_SELECTION
            }]
    },
    // Dont know how to capture an order
    {
        id: BotNodeId.ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER,
        botMessage: OrdersUncapturedOrdersBotMessage,
        options: useOrdersDontKnowCaptureOrderOptions
    },
    {
        id: BotNodeId.ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER_YES,
        botMessage: OrdersUncapturedOrdersYesBotMessage,
        options: () => INeedMoreHelpThatHelped
    },
    {
        id: BotNodeId.ORDERS_DONT_KNOW_HOW_TO_CAPTURE_ORDER_NO,
        botMessage: OrdersUncapturedOrdersNoBotMessage,
        options: () => INeedMoreHelpThatHelped
    },
    // Missed Capture Deadline
    {
        id: BotNodeId.ORDERS_MISSED_CAPTURE_DEADLINE,
        botMessage: BotMessages.OrdersExpirationDateSurpassed,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.ORDERS_EXPIRATION_DATE_SURPASSED
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.ORDERS_MISSED_CAPTURE_DEADLINE_NO
            }]
    },
    {
        id: BotNodeId.ORDERS_EXPIRATION_DATE_SURPASSED,
        botMessage: BotMessages.OrdersCustomerCreditPaymentMethod,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.ORDERS_EXPIRATION_DATE_SURPASSED_CREDIT
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.ORDERS_MISSED_CAPTURE_DEADLINE_NO
            }]
    },
    {
        id: BotNodeId.ORDERS_EXPIRATION_DATE_SURPASSED_CREDIT,
        botMessage: BotMessages.OrdersCustomerCreditPaymentMethodYes,
        options: () => [{
                value: 'helpbot.options.contactSupportChannel',
                next: UxEvent.GO_TO_CHANNEL_SELECTION
            }]
    },
    {
        id: BotNodeId.ORDERS_MISSED_CAPTURE_DEADLINE_NO,
        botMessage: OrdersExpirationDateSurpassedNo,
        options: () => INeedMoreHelpThatHelped
    },
    // Need to refund an order
    {
        id: BotNodeId.ORDERS_REFUND_AN_ORDER,
        botMessage: OrdersIsOrderCapturedBotMessage,
        options: () => [{
                value: 'helpbot.options.yes',
                next: BotNodeId.ORDERS_FULLY_CAPTURED_YES
            },
            {
                value: 'helpbot.options.no',
                next: BotNodeId.ORDERS_FULLY_CAPTURED_NO
            }, {
                value: 'helpbot.options.partially',
                next: BotNodeId.ORDERS_FULLY_CAPTURED_PARTIALLY
            }]
    }, {
        id: BotNodeId.ORDERS_FULLY_CAPTURED_YES,
        botMessage: BotMessages.OrdersReturnCaptured,
        options: () => INeedMoreHelpThatHelped
    }, {
        id: BotNodeId.ORDERS_FULLY_CAPTURED_NO,
        botMessage: OrdersIsOrderCapturedNoBotMessage,
        options: () => INeedMoreHelpThatHelped
    }, {
        id: BotNodeId.ORDERS_FULLY_CAPTURED_PARTIALLY,
        botMessage: OrdersIsOrderCapturedNoBotMessage,
        options: () => INeedMoreHelpThatHelped
    }];
export default ordersFlow;
